<template>
  <filtertron-tray-section
    id="field-configurator-categories"
    :title="lang.get('fields.form.categories.text')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <category-config
        :resource="field"
        :categories="categories"
        :placeholder="lang.get('fields.form.categories.placeholder')"
        :all-categories-label="lang.get('fields.form.categories_all.label')"
        :select-categories-label="
          lang.get('fields.form.categories_select.label')
        "
        @input="config => $emit('input', config)"
      />
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import CategoryConfig from '@/lib/components/Categories/CategoryConfig';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    CategoryConfig,
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['categories'])
  }
};
</script>
